"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandlingFeePricingTypeEnum = exports.HandlingFeeCostRuleTypeEnum = exports.HandlingFeeRestrictionTypeEnum = void 0;
var HandlingFeeRestrictionTypeEnum;
(function (HandlingFeeRestrictionTypeEnum) {
    HandlingFeeRestrictionTypeEnum["WEIGHT"] = "weight_limit";
    HandlingFeeRestrictionTypeEnum["SUBTOTAL"] = "subtotal_limit";
    HandlingFeeRestrictionTypeEnum["REGION"] = "region";
    HandlingFeeRestrictionTypeEnum["CURRENCY"] = "currency";
    HandlingFeeRestrictionTypeEnum["PRICING_TYPE"] = "pricing_type";
})(HandlingFeeRestrictionTypeEnum = exports.HandlingFeeRestrictionTypeEnum || (exports.HandlingFeeRestrictionTypeEnum = {}));
var HandlingFeeCostRuleTypeEnum;
(function (HandlingFeeCostRuleTypeEnum) {
    HandlingFeeCostRuleTypeEnum["BASE"] = "base";
    HandlingFeeCostRuleTypeEnum["TIERS"] = "tiers";
})(HandlingFeeCostRuleTypeEnum = exports.HandlingFeeCostRuleTypeEnum || (exports.HandlingFeeCostRuleTypeEnum = {}));
var HandlingFeePricingTypeEnum;
(function (HandlingFeePricingTypeEnum) {
    HandlingFeePricingTypeEnum["RETAIL"] = "retail";
    HandlingFeePricingTypeEnum["WHOLESALE"] = "wholesale";
    // not sure if we need any here, since restriction can just be removed
    HandlingFeePricingTypeEnum["ANY"] = "any";
})(HandlingFeePricingTypeEnum = exports.HandlingFeePricingTypeEnum || (exports.HandlingFeePricingTypeEnum = {}));
